<template>
  <div>
    <!-- Hero Section -->
    <section class="py-20 bg-gradient-dark">
      <div class="container mx-auto px-6 text-center">
        <div class="flex items-center justify-center mb-6">
          <router-link to="/services" class="text-gold-400 hover:text-gold-300 transition-colors duration-300 mr-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </router-link>
          <h1 class="text-4xl md:text-6xl font-display font-bold text-gold-400">
            REMOVABLE PROSTHETICS
          </h1>
        </div>
        <p class="text-xl text-gold-300 max-w-3xl mx-auto">
          Comfortable and functional removable dental solutions for optimal oral health and aesthetics.
        </p>
      </div>
    </section>

    <!-- Products -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <!-- DENTURES -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">1</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              DENTURES
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Complete Acrylic Dentures</h3>
                <p class="text-gray-300 text-lg">Full dentures with natural aesthetics and comfortable fit</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Flexible Partial Dentures</h3>
                <p class="text-gray-300 text-lg">Metal-free partials for enhanced comfort and aesthetics</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Cast Partials</h3>
                <p class="text-gray-300 text-lg">Traditional metal framework partials for durability</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Hybrid / Fixed Dentures</h3>
                <p class="text-gray-300 text-lg">Implant-supported fixed or removable solutions</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Reline</h3>
                <p class="text-gray-300 text-lg">Denture adjustments for improved fit and comfort</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Flipper</h3>
                <p class="text-gray-300 text-lg">Temporary partial dentures for immediate needs</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Night Guard -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">2</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              NIGHT GUARD
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Thermoplastic Night Guard</h3>
                <p class="text-gray-300 text-lg">Heat-molded for accurate fitting and comfort</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Pro-Form Night Guard</h3>
                <p class="text-gray-300 text-lg">Pressure-laminated for durability and protection</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Sport Guard</h3>
                <p class="text-gray-300 text-lg">Protective mouthguards for athletic activities</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Essix Retainer</h3>
                <p class="text-gray-300 text-lg">Clear retainers for orthodontic maintenance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Back to Services -->
    <section class="py-20">
      <div class="container mx-auto px-6 text-center">
        <router-link to="/services" class="btn-secondary inline-flex items-center text-lg py-4 px-8">
          <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to All Services
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RemovableServices'
}
</script>